import { useMemo } from 'react';
import DOMPurify from 'dompurify';
import './RichTextViewer.css';

/**
 * 安全顯示富文本 HTML（商品詳細說明）。
 *
 * 縱深防禦：後端存入前已用 jsoup 消毒一次，這裡顯示前再用 DOMPurify 消毒一次。
 *   - 允許影片 <iframe>，但只限 YouTube / Vimeo 網域（其餘 iframe 移除）
 *   - 連結強制補 rel="noopener noreferrer"，避免 target=_blank 的 tabnabbing
 */

const ALLOWED_IFRAME_HOSTS = [
  'youtube.com', 'www.youtube.com', 'youtube-nocookie.com',
  'www.youtube-nocookie.com', 'player.vimeo.com', 'vimeo.com',
];

// 註冊一次性的 DOMPurify hook（模組載入時設定即可）
let hookRegistered = false;
function ensureHooks() {
  if (hookRegistered) return;
  DOMPurify.addHook('uponSanitizeElement', (node) => {
    if (node.tagName === 'IFRAME') {
      const src = node.getAttribute('src') || '';
      let ok = false;
      try {
        const host = new URL(src).hostname.toLowerCase();
        ok = ALLOWED_IFRAME_HOSTS.includes(host);
      } catch {
        ok = false;
      }
      if (!ok && node.parentNode) node.parentNode.removeChild(node);
    }
  });
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target')) {
      node.setAttribute('rel', 'noopener noreferrer nofollow');
    }
  });
  hookRegistered = true;
}

function RichTextViewer({ html, className }) {
  const clean = useMemo(() => {
    if (!html) return '';
    ensureHooks();
    return DOMPurify.sanitize(html, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target'],
    });
  }, [html]);

  if (!clean) return null;

  return (
    <div
      className={`rt-view${className ? ' ' + className : ''}`}
      // 已經 DOMPurify 消毒過（後端 jsoup 也消毒過）
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}

export default RichTextViewer;
